<template>
  <div class="text-center fullscreen">
    <v-container>
      <v-row class="thank">
        <v-col cols="12">
          <p class="display-2 font-weight-bold">Settings</p>
        </v-col>
        <v-col cols="12">
          <p class="">Key in the Device Code to register this device.</p>
          <p class="caption">You can setup and get the Device Code from the Admin Portal</p>
        </v-col>
        <v-col v-show="hasError" cols="12">
          <p class="red--text">Device code "{{deviceCodeInput}}" does not exist</p>
        </v-col>
          <v-col cols="6">
            <v-form ref="deviceCodeForm">
              <v-text-field
                v-model="deviceCodeInput"
                label="Device Code"
                outlined
                dense
                hide-details
                required
                :disabled="!!this.registeredDeviceId"
                :rules="[
                    (v) => !!v || 'This is required'
                ]"
              ></v-text-field>
            </v-form>
          </v-col>
          <v-col cols="3">
            <v-btn
              v-if="this.registeredDeviceId"
              @click="resetRegisteredDevice"
              color="red"
              block
              text
              :loading="loading"
            >Deregister</v-btn>
            <v-btn
              v-else
              @click="searchAndSave"
              color="primary"
              block
              :loading="loading"
            >Save & Close</v-btn>
          </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      deviceCodeInput: null,
      loading: false,
      hasError: false
    };
  },
  mounted() {
    console.log(this.registeredDeviceId)
    this.deviceCodeInput = this.registeredDeviceCode
  },
  computed: {
    ...mapState({
      registeredDeviceId: state => state.device.deviceId,
      registeredDeviceCode: state => state.device.deviceCode
    })
  },
  methods: {
    searchAndSave() {
      this.hasError = false
      if (this.$refs.deviceCodeForm.validate()) {
        this.loading = true
        this.$store.dispatch('device/fetchDeviceByCode', this.deviceCodeInput)
        .then(res => {
          this.loading = false
          if (res) {
            this.$store.commit('device/registerDevice', {
              id: res.id,
              code: res.code
            })
            this.$router.push('/')
          } else {
            this.hasError = true
          }
        })
      }
    },
    resetRegisteredDevice() {
      this.$store.commit('device/reset')
      this.deviceCodeInput = null
    }
  }
};
</script>
<style>
.fullscreen {
  display: 'block';
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
}
.thank {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  justify-items: center;
}
</style>
